const Badge = ({ children, type = 'neutral', icon: Icon }) => {
  const styles = {
    neutral: 'bg-zinc-100 text-zinc-600 border-zinc-200',
    highlight: 'bg-zinc-900 text-white border-zinc-900',
    pending: 'bg-orange-50 text-orange-600 border-orange-100',
    admin: 'bg-indigo-50 text-indigo-600 border-indigo-100',
    bread: 'bg-red-50 text-red-700 border-red-200',
    halfBread: 'bg-amber-50 text-amber-700 border-amber-200',
  };
  return (
    <span
      className={`px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wider border flex items-center gap-1 ${styles[type] || styles.neutral}`}
    >
      {Icon && <Icon className="w-3 h-3" />}
      {children}
    </span>
  );
};

export default Badge;
